module.exports = __webpack_public_path__ + "8e5ddc4a0e3daf2f1204995a19e501d9.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/coronabedingteinvestitionen.svg
// module id = 964
// module chunks = 0